import { render, staticRenderFns } from "./NotificationTemplateTabs.vue?vue&type=template&id=60d88550&scoped=true"
import script from "./NotificationTemplateTabs.vue?vue&type=script&lang=js"
export * from "./NotificationTemplateTabs.vue?vue&type=script&lang=js"
import style0 from "./NotificationTemplateTabs.vue?vue&type=style&index=0&id=60d88550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d88550",
  null
  
)

export default component.exports